import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { BonusSettlement } from '../../models/bonus-settlement';

export class BonusSettlementsOverviewApi {
    constructor(protected baseUrl: string) {}

    public getBonusSettlementsOverview(): Promise<ApiResult<PaginatedResponse<BonusSettlement>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements`),
            response => response.data
        );
    }
}
